<template>
  <div :class="$style.ctn">
    <div v-if="staticInformation" :class="$style.grid">
      <div v-if="staticInformation.trid.length" :class="$style.block">
        <h3 :class="[$style.title, com.subtitle]">
          TRiD
        </h3>
        <div :class="[$style.content, $style.contentSimple]">
          <table :class="[com.keyValueValue, $style.simpleTable]">
            <tbody>
              <tr v-for="(row, i) in staticInformation.trid" :key="i">
                <th :class="$style.tridExt">
                  {{ row.extension }}
                </th>
                <td :class="$style.tridDel">
                  |
                </td>
                <td :class="$style.tridValue">
                  {{ row.value }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="staticInformation.exif.length" :class="$style.block">
        <h3 :class="[$style.title, com.subtitle]">
          EXIF
        </h3>
        <div :class="[$style.content, $style.contentSimple]">
          <template v-for="[extension, exifValues] in staticInformation.exif">
            <h4 :class="$style.exifExe">
              {{ extension }}
            </h4>
            <table :class="$style.simpleTable">
              <tbody>
                <tr v-for="([name, value], index) in exifValues" :key="index">
                  <th :class="[com.keyValueName, $style.keyValueName]">
                    {{ name }}:
                  </th>
                  <td :class="[com.keyValueValue, $style.mayBeList]">
                    <ValueCell :value="value" />
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
        </div>
      </div>
      <div v-if="staticInformation.summary" :class="[$style.block, $style.blockFull]">
        <h3 :class="[$style.title, com.subtitle]">
          {{ staticInformation.summary.key }}
        </h3>
        <div :class="[$style.content, $style.contentSimple]">
          <table :class="$style.simpleTable">
            <tbody>
              <tr v-for="({ key, value }, index) in staticInformation.summary.value" :key="index">
                <th :class="[com.keyValueName, $style.keyValueName]">
                  {{ key }}:
                </th>
                <td :class="[com.keyValueValue, $style.mayBeList]">
                  <ValueCell :value="value" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="staticInformation.dosHeader" :class="$style.block">
        <h3 :class="[$style.title, com.subtitle]">
          {{ staticInformation.dosHeader.key }}
        </h3>
        <div :class="[$style.content, $style.contentSimple]">
          <table :class="$style.simpleTable">
            <tbody>
              <tr v-for="({ key, value }, index) in staticInformation.dosHeader.value" :key="index">
                <th :class="[com.keyValueName, $style.keyValueName]">
                  {{ key }}:
                </th>
                <td :class="[com.keyValueValue, $style.mayBeList]">
                  <ValueCell :value="value" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="staticInformation.peHeaders" :class="$style.block">
        <h3 :class="[$style.title, com.subtitle]">
          PE Headers
        </h3>
        <div :class="[$style.content, $style.contentSimple]">
          <table :class="$style.simpleTable">
            <tbody>
              <tr v-for="({ key, value }, index) in staticInformation.peHeaders.value" :key="index">
                <th :class="[com.keyValueName, $style.keyValueName]">
                  {{ key }}:
                </th>
                <td :class="[com.keyValueValue, $style.mayBeList]">
                  <ValueCell :value="value" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="staticInformation.sections.length" :class="[$style.block, $style.blockFull]">
        <h3 :class="[$style.title, com.subtitle]">
          Sections
        </h3>
        <div :class="[$style.content, $style.sections]">
          <PaginationTable
            :head="sectionsHead"
            :values="staticInformation.sections"
            :table-wrapper-class="media.sectionTableWrapper"
          />
        </div>
      </div>
      <div v-if="staticInformation.resources.length" :class="[$style.block, $style.blockFull]">
        <h3 :class="[$style.title, com.subtitle]">
          Resources
        </h3>
        <div :class="$style.content">
          <PaginationTable
          :head="resourcesHead"
          :values="staticInformation.resources"
          :table-wrapper-class="media.sectionTableWrapper"
          />
        </div>
      </div>
      <div v-if="staticInformation.imports.length" :class="$style.block">
        <h3 :class="[$style.title, com.subtitle]">
          Imports
        </h3>
        <div :class="[$style.content]">
          <PaginationTable 
            :show-head="false"
            :head="importsHead"
            :values="staticInformation.imports"
          />
        </div>
      </div>
      <div v-if="staticInformation.exports.length" :class="$style.block">
        <h3 :class="[$style.title, com.subtitle]">
          Exports
        </h3>
        <div :class="$style.content">
          <PaginationTable :tight="true" :head="exportsHead" :values="staticInformation.exports" :table-wrapper-class="media.sectionTableWrapper" />
        </div>
      </div>
    </div>
    <div :class="[com.message, $style.noData]">
      No data.
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import PaginationTable from './PaginationTable.vue';
import ValueCell from './ValueCell.vue';

export default defineComponent({
  components: { PaginationTable, ValueCell },
  inject: ['root'],
  data() {
    return {
      sectionsHead: [
        { value: 'Name', width: 150 },
        { value: 'Virtual Address', width: 130 },
        { value: 'Virtual Size', width: 110 },
        { value: 'Raw Size', width: 90 },
        { value: 'Charateristics', width: 490 },
        { value: 'Entropy', width: 110 },
      ],
      resourcesHead: [
        { value: 'Title', width: 350 },
        { value: 'Entropy', width: 130 },
        { value: 'Size', width: 130 },
        { value: 'Codepage', width: 190 },
        { value: 'Language', width: 130 },
        { value: 'Type', width: 150 },
      ],
      importsHead: [{ value: 'Name', width: 533 }],
      exportsHead: [
        { value: 'Title', width: 240 },
        { value: 'Ordinal', width: 130 },
        { value: 'Address', width: 150 },
      ],
    };
  },
  computed: {
    staticInformation() {
      return this.root.staticInformation;
    },
  },
});
</script>

<style lang="scss" module>
.ctn {
  padding-top: 20px;
}
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 18px 12px;

  @media screen and (max-width: 767px) {
    display: block;

    .block {
      margin-bottom: 18px;
    }
  }

  &:not(:empty) + .noData {
    display: none;
  }
}

.block {
  display: flex;
  flex-direction: column;
}
.blockFull {
  grid-column: span 2;
}
.title {
  flex: none;
  & + .content {
    margin-top: 8px;
  }
}

.content {
  flex: 1 1 auto;
  border-radius: 6px;
  // overflow: hidden;
}
.contentSimple {
  background: var(--secondary-cell-color);
  padding: 20px;
  border: 1px solid var(--table-border-color);
  tr + tr { 
    td, th {
      padding-top: 10px;
    }
  }
}
.simpleTable {
  td, th {
    vertical-align: top;
  }
}
.keyValueName {
  width: 155px;
  padding-right: 30px;
  box-sizing: content-box;
}

.exifExe {
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.02em;
  color: #2f3543;

  font-style: normal;
  font-weight: normal;

  & + .simpleTable {
    margin-top: 10px;

    & + .exifExe {
      margin-top: 17px;
    }
  }
}
.tridDel {
  padding-left: 14px;
  padding-right: 14px;
}
.sections {
  z-index: 2;
}
.mayBeList {
  word-break: break-all;

  & > ul {
    list-style: none;
    & > li + li {
      margin-top: 10px;
    }
  }
}

.tridExt {
  white-space: nowrap;
  text-align: start;
  font-weight: inherit;
}
.tridValue {
  width: 100%;
}
</style>

<style lang="scss" src="./common.module.scss" module="com"></style>
<style lang="scss" src="./media.module.scss" module="media"></style>
